module.exports = __webpack_public_path__ + "img/41.3c932f67.jpg";